import axios from 'axios';
import { showError } from '../utils';
import config from '../config';
import { store } from '../store';

// Generic network call function to handle common API request patterns
function networkCall({ method, url, headers, params, data, ...extraOptions }) {
  return axios({
    method,
    url,
    headers,
    params,
    data,
    ...extraOptions,
  })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const error = new Error('Invalid response');
        error.data = responseBody;
        throw error;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}
export const getUserVaccinationRequests = (authToken) => {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/care/v2/vaccinations`,
    headers,
  });
};

export const getUserVaccinationTypes = async (
  authToken,
  networkCenterId,
  updatedVaccineId,
  numberOfFiltersApplied,
  relativeId
) => {
  console.log('updatedVaccineId', updatedVaccineId);
  const headers = {
    authorization: authToken,
  };
  const queryParams = new URLSearchParams();

  if (networkCenterId) {
    queryParams.append('networkCenterId', networkCenterId);
  }
  if (updatedVaccineId) {
    //append only when vaccines are selected and network center is there
    queryParams.append('subVaccineId', updatedVaccineId);
  }
  if (numberOfFiltersApplied) {
    queryParams.append('categoryId', numberOfFiltersApplied);
  }
  if (relativeId) {
    queryParams.append('relativeId', relativeId);
  }
  return networkCall({
    method: 'get',
    url: `${
      config.apiBaseUrl
    }/cashless-vaccination/v2/getVaccinationSubCategories?${queryParams.toString()}`,
    headers,
  });
};

export const getCashlessVaccinationCenters = (
  authToken,
  latitude,
  longitude,
  categoryId
) => {
  const headers = {
    authorization: authToken,
  };
  const queryParams = new URLSearchParams();
  if (latitude) {
    queryParams.append('lat', latitude);
  }
  if (longitude) {
    queryParams.append('long', longitude);
  }
  if (categoryId) {
    queryParams.append('categoryId', categoryId);
  }
  return networkCall({
    method: 'get',
    url: `${
      config.apiBaseUrl
    }/cashless-vaccination/v2/vaccinationCenters?${queryParams.toString()}`,
    headers,
  });
};

export const fetchVaccinationFilters = (
  authToken,
  lat,
  long,
  searchInFilterModal,
  categoryId
) => {
  let queryParams = new URLSearchParams();
  if (searchInFilterModal) {
    queryParams.append('searchText', searchInFilterModal);
  }
  if (lat) {
    queryParams.append('lat', lat);
  }
  if (long) {
    queryParams.append('long', long);
  }
  if (categoryId) {
    queryParams.append('categoryId', categoryId);
  }

  const headers = { authorization: authToken };
  return networkCall({
    method: 'get',
    url: `${
      config.apiBaseUrl
    }/cashless-vaccination/v2/getVaccinationCategories?${queryParams.toString()}`,
    headers,
  });
};

export const getSelectedHospitalProfile = (authToken, openNetworkId) => {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/cashless-vaccination/get-center-profile?centerId=${openNetworkId}`,
    headers,
  });
};

export const getBookingDate = (authToken, networkId, vaccineId) => {
  const headers = {
    authorization: authToken,
  };
  const queryParams = new URLSearchParams();
  if (networkId) {
    queryParams.append('centerId', networkId);
  }
  if (vaccineId) {
    queryParams.append('vaccinationSubCategoryId', vaccineId);
  }
  return networkCall({
    method: 'get',
    url: `${
      config.apiBaseUrl
    }/cashless-vaccination/v2/vaccinationDateSlots?${queryParams.toString()}`,
    headers,
  });
};

export const getBookingSlots = (authToken, date, vaccinationId, centerId) => {
  const headers = { authorization: authToken };
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/cashless-vaccination/get-slots?date=${date}&vaccinationId=${vaccinationId}&centerId=${centerId}`,
    headers,
  });
};

export const getAppointment = (authToken) => {
  const headers = { authorization: authToken };
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/cashless-vaccination/get-appointment`,
    headers,
  });
};

export const fetchVaccinationStatus = (authToken, requestId) => {
  const headers = { authorization: authToken };
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/cashless-vaccination/vaccination-request-status?requestId=${requestId}`,
    headers,
  });
};

export const cancelAppointment = (authToken, requestId) => {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/cashless-vaccination/cancel-request?requestId=${requestId}`,
    headers,
    data: {},
  });
};

export function trackVaccinationPayment(transactionId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/cashless-vaccination/vaccination/callback`,
    headers,
    data: {
      orderId: transactionId,
    },
  });
}

export const createVaccineCart = async (
  authToken,
  cartId,
  categoryId,
  networkCenterId,
  vaccinationSubCategoryId,
  vaccineCost,
  selectedDate,
  selectedSlot,
  edit,
  selectedRelative
) => {
  const headers = {
    authorization: authToken,
  };
  const queryParams = new URLSearchParams();
  if (edit) {
    queryParams.append('edit', edit);
  }
  const requestBody = {
    cartId: cartId,
    categoryId: categoryId,
    dateSelected: selectedDate,
    networkCenterId: networkCenterId,
    timeSlotId: selectedSlot,
    vaccinationSubCategoryId: vaccinationSubCategoryId,
    vaccineCost: vaccineCost,
    ...(selectedRelative !== 'self' && { relativeId: selectedRelative }),
  };
  return networkCall({
    method: 'post',
    url: `${
      config.apiBaseUrl
    }/cashless-vaccination/v2/create-vaccination-cart?${queryParams.toString()}`,
    headers,
    data: requestBody,
  });
};

export function removeElementFromVaccineCart(
  authToken,
  cartDiscard,
  cartId,
  vaccinationSubCategoryId
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/cashless-vaccination/v2/remove-vaccination`,
    headers,
    data: {
      cartDiscard: cartDiscard,
      cartId: cartId,
      vaccinationSubCategoryId: vaccinationSubCategoryId,
    },
  });
}

export function parentVaccine(authToken, parentOrderId) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/cashless-vaccination/v2/parent-request-details?parentOrderId=${parentOrderId}`,
    headers,
  });
}

export const getVaccinationConfirmation = (
  authToken,
  cartId,
  centerId,
  relativeId
) => {
  const queryParams = new URLSearchParams();
  if (relativeId) {
    queryParams.append('relativeId', relativeId);
  }
  queryParams.append('cartId', cartId);
  queryParams.append('centerId', centerId);
  const headers = { authorization: authToken };
  return networkCall({
    method: 'get',
    url: `${
      config.apiBaseUrl
    }/cashless-vaccination/v2/vaccination-cart-details?${queryParams.toString()}`,
    headers,
  });
};

export function initiateEmergencyCall(authToken, requestId) {
  const headers = {
    authorization: authToken,
  };
  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/cashless-vaccination/v2/${requestId}/initiate-call-by-user`,
    headers,
    data: {},
  });
}

export const getVaccinationFeedback = (authToken, rating) => {
  const headers = { authorization: authToken };
  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/cashless-vaccination/v2/get-vaccination-reviews/${rating}`,
    headers,
  });
};

export function postRating(authToken, requestId, reviewId, starRating, others) {
  const headers = {
    authorization: authToken,
  };
  const body = {
    requestId,
    reviewId,
    starRating,
    //send others key if others is not empty
    ...(others && { others }),
  };
  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/cashless-vaccination/v2/post-vaccination-review`,
    headers,
    data: body,
  });
}

export function payForAppointmentRequest(
  cartId,
  relativeId,
  finalFee,
  authToken,
  history
) {
  const headers = {
    authorization: authToken,
  };
  const redirectToPaymentGateway = () => {
    const url =
      relativeId === 'self'
        ? `${
            config.apiBaseUrl
          }/cashless-vaccination/v2/book-vaccinations?cartId=${cartId}&auth=${
            authToken.split(' ')[1]
          }`
        : `${
            config.apiBaseUrl
          }/cashless-vaccination/v2/book-vaccinations?cartId=${cartId}&relativeId=${relativeId}&auth=${
            authToken.split(' ')[1]
          }`;
    window.location.assign(url);
    return window.location.assign(url);
  };

  if (finalFee === true || finalFee.toString() === '0') {
    console.log("finalFee === true || finalFee.toString() === '0'", finalFee);
    return redirectToPaymentGateway();
  }
  const url =
    relativeId === 'self'
      ? `${config.apiBaseUrl}/cashless-vaccination/v2/book-vaccinations?cartId=${cartId}`
      : `${config.apiBaseUrl}/cashless-vaccination/v2/book-vaccinations?cartId=${cartId}&relativeId=${relativeId}`;
  return window.PhonePe.PhonePe.build(window.PhonePe.Constants.Species.web)
    .then((sdk) => {
      // Call the API to fetch the data context
      console.log('sdk', sdk);
      return axios
        .get(url, {
          headers,
        })
        .then((res) => {
          const responseBody = res.data;
          if (responseBody.message === 'success') {
            const context = responseBody.data;
            if (sdk.isMethodSupported('openPaymentsPage')) {
              history.replace('/processing-payment', {
                orderType: 'vaccination',
                transactionId: responseBody.orderId,
                successPage: `vaccination/preview`,
                failurePage: `vaccination/preview`,
                failureStateParameters: {
                  paymentFailed: true,
                },
              });
              return sdk.openPaymentsPage(
                'Visit',
                context,
                `${config.rootUrl}vaccination/preview`,
                'https://getvisitapp.com/img/png/Visit_logo.png',
                [
                  {
                    'Order For': 'Doctor Consultation',
                  },
                ]
              );
            }
            throw new Error('Phonepe method not supported');
          } else if (responseBody.message === 'failure') {
            history.push('/home', {
              bookingFailed: true,
              errorMessage: responseBody.errorMessage,
            });
            return;
          } else {
            throw new Error('Failed to get payment context');
          }
        });
    })
    .catch((err) => {
      console.log('catch err', err);
      try {
        const parsedError = JSON.parse(err);
        if (
          parsedError &&
          (parsedError.error_code === 'PAYMENT_DISMISS' ||
            parsedError.error_code === 'PAYMENT_TIMEOUT')
        ) {
          store.dispatch({
            type: 'SHOW_ERROR',
            payload: {
              errorTitle: 'Something went wrong',
              errorDesc: 'Your payment failed. Please retry your payment.',
            },
          });
          history.push('/home', {
            paymentFailed: true,
          });
          return;
        }
        // in case of android, it could still be a null error.
        if (parsedError === 'null' || parsedError === null) {
          store.dispatch({
            type: 'SHOW_ERROR',
            payload: {
              errorTitle: 'Something went wrong',
              errorDesc: 'Your payment failed. Please retry your payment.',
            },
          });
          history.push('/home', {
            paymentFailed: true,
          });
          return;
        }
      } catch (e) {
        console.log('error', e);
        //  Since we couldn't parse the error, it means it's not a string and hence not a phonepe dismiss/timeout error.
        // Not on phonepe in-app or some other error.
        // send to payment
        return redirectToPaymentGateway();
      }
    });
}
